import React from 'react';
import { createRoot } from 'react-dom/client';
import { PropertyResults } from './components/PropertyResults';
import '../../_shared/oceanSearchContext';

document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll<HTMLElement>('.wp-block-ocean-property-results');

	containers.forEach((container) => {
		const ajaxUrl = window.oceanSearchData?.ajaxUrl || '';
		const lockedScope = window.oceanSearchData?.lockedScope || null;
		const googleMapsApiKey = window.oceanSearchData?.googleMapsApiKey || '';

		const root = createRoot(container);
		root.render(
			<PropertyResults ajaxUrl={ajaxUrl} lockedScope={lockedScope} googleMapsApiKey={googleMapsApiKey} />
		);
		});
	});
